import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./awDataSupplied.png"

const AWデータ支給設計 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { awDataSupplied: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"AWデータ支給設計\n（CAD／LIB必須）"}
      src={img}
      helpURL={HELP_LINKS["AWデータ支給設計（CAD／LIB必須）"]}
    >
      <RadioGroup
        name={estimateField.awDataSupplied.key}
        selectedValue={values.awDataSupplied}
        onChange={handlers.radio}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["AWデータ支給設計（CAD／LIB必須）"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["AWデータ支給設計（CAD／LIB必須）"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.awDataSupplied} />
    </OneClickField>
  )
}

export default AWデータ支給設計
